import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore/lite"
import { getAuth } from "firebase/auth";
//I jave left it blank you will copy and paste it from your firebase config mentioned in pic above
const firebaseConfig = {
    apiKey: "AIzaSyAeClpnBEb4IfOJJNmslGqj6UxDUoigl_c",
    authDomain: "help-al-haouz.firebaseapp.com",
    projectId: "help-al-haouz",
    storageBucket: "help-al-haouz.appspot.com",
    messagingSenderId: "101838199023",
    appId: "1:101838199023:web:a85cda8454a58a4a18631a",
    measurementId: "G-639DHXVN7J"
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app)
const db = getFirestore()



export {auth, db}